import { Box, Tab, Tabs, useTheme } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import Countries from './Countries/Countries';
import GeneralInfo from './GeneralInfo/GeneralInfo';
import usePlanStore from '../../../../store/planStore';
import BackToList from './BackToList/BackToList';
import PlanSummary from './PlanSummary/PlanSummary';

export default function Plan() {
  const { t } = useTranslation();
  const { activeTab, setActiveTab, isGeneralInfoFilled } = usePlanStore();
  const theme = useTheme();

  return (
    <Box width="100%" sx={{ backgroundColor: theme.palette.lightGrey.main }}>
      <Box
        sx={{
          fontWeight: 700,
          fontSize: 14,
          borderRadius: '5px',
          mx: '20px',
          mt: '10px',
        }}
      >
        <BackToList />
        <TabContext value={activeTab}>
          <Tabs
            value={activeTab}
            aria-label="Flow Tabs"
            onChange={(event, newValue) => setActiveTab(newValue)}
            sx={{
              justifyContent: 'flex-start',
              display: 'flex',
              borderBottom: '1px solid #bdbdbd',
              height: '1px',
              width: '100%',
              padding: 0,
            }}
          >
            <Tab
              label={t('mediaPlanning.generalInfo')}
              id="vt0"
              value="generalInfo"
            />
            <Tab
              label={t('mediaPlanning.countries')}
              id="vt1"
              value="countries"
              disabled={!isGeneralInfoFilled}
            />
            <Tab
              label={t('mediaPlanning.planSummary')}
              id="vt2"
              value="planSummary"
              disabled={!isGeneralInfoFilled}
            />
          </Tabs>
          <TabPanel value="generalInfo" sx={{ p: 0 }}>
            <GeneralInfo />
          </TabPanel>
          <TabPanel value="countries" sx={{ p: 0 }}>
            <Countries />
          </TabPanel>
          <TabPanel value="planSummary" sx={{ p: 0 }}>
            <PlanSummary />
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
}
